module.exports = __webpack_public_path__ + "static/media/italian-pizza.f3590765.jpg";